import { CoreIcon } from '../core-icon';
import negativeCircleFillSVG from '../../assets/icons/negative-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const NegativeCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={negativeCircleFillSVG} {...props} />;
};
